import { defaultAxios, IParams } from './base';

export interface IMutatePromotionEntry extends IParams {
  custSeq: string;
  promotionSeq: string;
  reuseYn: string;
  otherYn: string;
}

export const mutatePromotionEntry = (params: any) => {
  return defaultAxios().put(`/promotion/entry`, params);
};
